import SortIcon from './SortIcon';
import './SortIcon.scss';

export default SortIcon;